export default __webpack_public_path__ + "static/media/20_dangerous_flower.7bd73908.png";